import { privateHttp } from "~/config/axios";
import { API_ENDPOINTS } from "~/config/endpoints";
import { PetCalendarList } from "~/types/common";
import { useQuery } from "@tanstack/react-query";

export interface NoticeDataType {
  type: string;
  message: string;
}

export const NOTICE_QUERY_KEYS = {
  calendar: ["calendar", "pet", "list", "schedule"],
} as const;

const getCalendarPetList = async () => {
  try {
    const { data } = await privateHttp.get(
      API_ENDPOINTS.USER_CALENDAR.CALENDAR_PET_LIST
    );
    // console.log("data", data);
    return data.data;
  } catch (error) {
    console.error("API 호출 에러:", error);
    throw error;
  }
};

export const useCalendarPetList = () => {
  return useQuery({
    queryKey: [...NOTICE_QUERY_KEYS.calendar],
    queryFn: () => getCalendarPetList(),
    select: (data) => data,
  });
};

const getCalendarProductCount = async (request: PetCalendarList) => {
  try {
    const { data } = await privateHttp.get(
      API_ENDPOINTS.USER_CALENDAR.CALENDAR_PRODUCT_COUNT,
      { params: request }
    );
    // console.log("data", data);
    return data.data;
  } catch (error) {
    console.error("API 호출 에러:", error);
    throw error;
  }
};

export const useCalendarProductCount = (request: PetCalendarList) => {
  return useQuery({
    queryKey: [...NOTICE_QUERY_KEYS.calendar, request],
    queryFn: () => getCalendarProductCount(request),
    enabled:
      !!request.petSeq &&
      request.petSeq !== "" &&
      !!request.yearMonth &&
      request.yearMonth !== "",
  });
};

const getCalendarList = async (request: PetCalendarList) => {
  try {
    const { data } = await privateHttp.get(
      API_ENDPOINTS.USER_CALENDAR.CALENDAR_LIST,
      { params: request }
    );
    // console.log("data", data);
    return data.data;
  } catch (error) {
    console.error("API 호출 에러:", error);
    throw error;
  }
};

export const useCalendarList = (request: PetCalendarList) => {
  return useQuery({
    queryKey: [
      ...NOTICE_QUERY_KEYS.calendar,
      request.petSeq,
      request.yearMonthDay,
    ],
    queryFn: () => getCalendarList(request),
    enabled:
      !!request.petSeq &&
      request.petSeq !== "" &&
      !!request.yearMonthDay &&
      request.yearMonthDay !== "",
  });
};

// const getCalendarScheduleList = async (request: PetCalendarList) => {
//   try {
//     const { data } = await privateHttp.get(
//       API_ENDPOINTS.USER_CALENDAR.CALENDAR_SCHEDULE_LIST,
//       { params: request }
//     );
//     return data.data || {};
//   } catch (error) {
//     console.error("API 호출 에러:", error);
//     throw error;
//   }
// };

// export const useCalendarScheduleList = (request: PetCalendarList) => {
//   return useQuery({
//     queryKey: [
//       ...NOTICE_QUERY_KEYS.calendar,
//       request.petSeq,
//       request.yearMonth,
//     ],
//     queryFn: () => getCalendarScheduleList(request),
//     enabled:
//       !!request.petSeq &&
//       request.petSeq !== "" &&
//       !!request.yearMonth &&
//       request.yearMonth !== "",
//     select: (data) => data || {},
//   });
// };
